export const SELLER_USER_DENY_LIST =
  process.env.REACT_APP_SELLER_USER_DENY_LIST?.split(',').map(elm =>
    atob(elm),
  ) || [];

export const ALLOWED_SELLER_USER_ROUTES = [
  /^\/$/,
  /^\/pedido(.+)?$/,
  /^\/clientes(.+)?$/,
];
